import { createContext } from 'react';

/**
 * Three states, not two. "system" is a real preference — it means "keep
 * following the OS", which a plain light/dark boolean cannot express: once a
 * boolean is stored, the app stops responding to the OS switching at sunset.
 */
export type ThemePref = 'system' | 'light' | 'dark';

export interface ThemeModeContextValue {
  /** The user's stored preference — may be 'system'. */
  readonly pref: ThemePref;
  /** The concrete mode 'system' resolves to right now. Always 'light' or 'dark'. */
  readonly resolved: 'light' | 'dark';
  readonly setPref: (pref: ThemePref) => void;
  /** Advances pref: system -> light -> dark -> system. */
  readonly cycle: () => void;
}

/**
 * Theme-mode context is exported from a dedicated module so hot-reload works
 * for `AppThemeProvider` (react-refresh requires component-only modules) —
 * mirrors `shared/auth/authContext.ts`'s file-split pattern.
 */
export const ThemeModeContext = createContext<ThemeModeContextValue | undefined>(undefined);
